// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pb-nav {
  height: calc(100% - 50px);
  background-color: var(--ion-color-primary);
}

app-item-option {
  width: 100%;
}

.app-version {
  position: absolute;
  bottom: 10px;
  left: 10px;
  right: 10px;
  padding: 10px;
  background-color: var(--ion-color-primary);
  color: var(--ion-background-color);
  font-size: 16px;
  text-align: center;
  font-weight: 500;
  letter-spacing: 0.5px;
  opacity: 1;
  transition: none;
  font-family: sans-serif;
}

ion-content {
  --background: var(--ion-color-primary);
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/menu/menu.component.scss"],"names":[],"mappings":"AAAA;EACE,yBAAA;EACA,0CAAA;AACF;;AAEA;EACE,WAAA;AACF;;AAEA;EACE,kBAAA;EACA,YAAA;EACA,UAAA;EACA,WAAA;EACA,aAAA;EACA,0CAAA;EACA,kCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,qBAAA;EACA,UAAA;EACA,gBAAA;EACA,uBAAA;AACF;;AAEA;EACE,sCAAA;AACF","sourcesContent":[".pb-nav {\n  height: calc(100% - 50px); // Ajusta según altura del footer\n  background-color: var(--ion-color-primary);\n}\n\napp-item-option {\n  width: 100%;\n}\n\n.app-version {\n  position: absolute;\n  bottom: 10px;\n  left: 10px;\n  right: 10px;\n  padding: 10px;\n  background-color: var(--ion-color-primary);\n  color: var(--ion-background-color);\n  font-size: 16px;\n  text-align: center;\n  font-weight: 500;\n  letter-spacing: 0.5px;\n  opacity: 1;\n  transition: none;\n  font-family: sans-serif;\n}\n\nion-content {\n  --background: var(--ion-color-primary); // Para eliminar fondos blancos en Ion-content\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
